export const development = {
    env: '[dev]',
    api: {
        base: 'http://localhost:3033/api/api-config/api-request',
        compact: 'http://localhost:3033/api/api-config/compact',
        authorize: 'http://localhost:3033/api/authorize/authorize',
        login: 'http://localhost:3033/api/authorize/login',
        resetPassword: 'http://localhost:3033/api/authorize/reset-password',
        setNewPassword: 'http://localhost:3033/api/authorize/setNewPassword',
        meta: 'http://localhost:3033/api/api-config/meta',
    }
};



// WEBPACK FOOTER //
// ./src/environment/development.ts